import { render, staticRenderFns } from "./ChangelogModal.vue?vue&type=template&id=0a7879ef&scoped=true"
import script from "./ChangelogModal.vue?vue&type=script&lang=js"
export * from "./ChangelogModal.vue?vue&type=script&lang=js"
import style0 from "./ChangelogModal.vue?vue&type=style&index=0&id=0a7879ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7879ef",
  null
  
)

export default component.exports